import { get, internalDestroy, internalPost, internalPut } from './index';
import qs from 'qs';

export const getCities = ({ filters }) => {
  const queryString = qs.stringify(filters);

  return get(`/cities?${queryString}`);
};

export const getCity = ({ cityId }) => {
  if (!cityId) return Promise.resolve(null);

  return get(`/cities/${cityId}/details`);
};

export const createCity = ({ payload, locale }) => {
  return internalPost(`/cities?locale=${locale ?? 'en'}`, payload);
};

export const updateCity = ({ cityId, payload, locale = 'en' }) => {
  return internalPut(`/cities/${cityId}?locale=${locale}`, payload);
};

export const deleteCity = (cityId) => {
  return internalDestroy(`/cities/${cityId}`);
};
